export default __webpack_public_path__ + "static/media/22.a20a3446.png";